// Typed lazy loader for the third-party acknowledgements shown in the About
// dialog. The underlying JSON is generated by `scripts/gen-third-party-licenses.py`
// and is ~1 MB, so it is dynamically imported (a separate chunk) only when the
// Acknowledgements list is actually opened — never in the main bundle.

/** One third-party component bundled with the app. */
export interface AckItem {
  name: string;
  version: string;
  /** SPDX expression (or empty when the manifest declared none). */
  license: string;
  ecosystem: 'npm' | 'cargo';
  /** Hashes into `AckData.texts` for this package's verbatim license text(s). */
  textRefs: string[];
}

/** The de-duplicated acknowledgements payload. */
export interface AckData {
  items: AckItem[];
  /** Distinct license texts, keyed by a short content hash. */
  texts: Record<string, string>;
}

export async function loadAcknowledgements(): Promise<AckData> {
  const mod = await import('./acknowledgements.generated.json');
  return (mod.default ?? mod) as unknown as AckData;
}
